// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_CONTACT_MESSAGE_DIALOG_OPENER = "Ahoj. \u010eakujem za z\u00e1ujem. Po\u010fme sa dohodn\u00fa\u0165. :-)";
export const BZ2_CONTACT_MESSAGE_WAS_SENT = "Spr\u00e1va bola odoslan\u00e1.";
export const BZ2_JUST_SEND_MESSAGE = "Po\u0161li spr\u00e1vu";
export const BZ2_SEND_MESSAGE = "Po\u0161li spr\u00e1vu predajcovi";
export const BZ_CONTACT_SEND_NEXT_MESSAGE = "Po\u0161li \u010fal\u0161iu spr\u00e1vu";
export const BZ_CONTACT_SHOW_COMMUNICATION_WITH_SELLER = "Zobraz komunik\u00e1ciu s predajcom";
